const ASSIGNMENT_SOURCES_API = {
	ASSIGNMENT_SOURCES: '/assignment-sources',
	ASSIGNMENT_SOURCE: (id: number) => `/assignment-sources/${id}`,
	USERS: (id: number) => `/assignment-sources/${id}/users`,

	SCOPE_GROUP_LABELS: (id: number) =>
		`/assignment-sources/${id}/scopes/group-labels`,
	SCOPE_GROUPS: (id: number) => `/assignment-sources/${id}/scopes/groups`,
	SCOPE_ROLES: (id: number) => `/assignment-sources/${id}/scopes/roles`,
	SCOPE_USERS: (id: number) => `/assignment-sources/${id}/scopes/users`,

	USER_ACTIVITY_ASSIGNMENTS: (id: number) =>
		`/assignment-sources/${id}/user-activity-assignments`,

	RESET: (id: number) => `/assignment-sources/${id}/reset`,
	RESET_USERS: (id: number) => `/assignment-sources/${id}/reset-users`,
	UNASSIGN_USERS: (id: number) => `/assignment-sources/${id}/unassign-users`
};

export default ASSIGNMENT_SOURCES_API;
